import { render, staticRenderFns } from "./btn-toggle.vue?vue&type=template&id=4dcb3248&scoped=true"
import script from "./btn-toggle.vue?vue&type=script&lang=js"
export * from "./btn-toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb3248",
  null
  
)

export default component.exports